import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

import { PromoPage } from '../../../../admin/types'

import styles from './style.module.scss'

export const ProductCard = ({ title, previewUrl, url, hexColor }: PromoPage) => {
	return (
		<Link className={styles.card} href={url} target='_blank' rel='noopener noreferrer nofollow'>
			<div className={styles.name}>{title}</div>
			<Image alt={title} className={styles.image} loading='lazy' fill src={previewUrl} />
			<div style={{ background: hexColor }} className={styles.overlay} />
		</Link>
	)
}
